<template>
  <el-menu-item style="float:right" class="text-dark">
    <span style="font-size: 12pt;" class="font-weight-lighter">Balance</span><span class="font-weight-bold">
    {{ ( -userVOSBalance > 10)? (-userVOSBalance).toString().substr(0, 5) : (-userVOSBalance).toString().trim().replace('-', '').substr(0, 4) }} $
    </span>
    <span style="font-size: 12pt;margin-left: 20px;" class="font-weight-lighter">Consumption</span> <span class="font-weight-bold">
    {{ ( todayconsumption > 10)? todayconsumption.toString().substr(0, 5) : todayconsumption.toString().replace('-', '').substr(0, 4)}} $
  </span>
  </el-menu-item>
</template>

<script>


export default {
  props: {
    userVOSBalance: {
      required: false,
      default: "N/A"
    },
    userVOSOverdraft: {
      required: false,
      default: "N/A"
    },
    todayconsumption: {
      required: false,
      default: "N/A"
    }
  },
  data() {
    return {
      customerData: {},
      userId: $store.state['user-state'].profile.id,
      vosLink: null,
      vosDialogVisibility: false,
    }
  },
  mounted() {
    /*this.getCustomerFields({id: this.userId}).then((r) => {
      this.customerData = r
      this.iframeSrc = this.customerData.vos_recharge_link + '/login?username=' + this.customerData.vos_username + '&password=' + this.customerData.vos_password
    })*/
  },
  methods: {
    loginMan() {
      this.vosDialogVisibility = true
    },
    ...$mapActions('user-customer-features-api', {
      getCustomerFields: 'get',
      loginToVos: 'loginToVos',
    }),
  }
}
</script>
